// 群发，获客海报，预约插件，获客文章，扫码支付，活动插件，房产插件放到应用中心
// 分销放到商城去
export default [{
  path: '/',
  redirect: '/survey',
  hidden: true // 是否展示在侧边栏的菜单里
},
//  概览
{
  path: '/survey',
  component: 'Layout',
  redirect: '/survey/index',
  meta: {
    'menuName': 'Survey', // 一级菜单标题
    'icon': 'icon-gaikuang' // 一级菜单的图标
  },
  children: [{
    path: 'index',
    name: 'Survey',
    component: '/survey/index',
    meta: {
      keepAlive: false, // 是否缓存页面
      refresh: false,
      title: '', // 页面头部的标题
      isOnly: true, // 单独页面
      auth: ['view', 'add', 'edit', 'del', 'outport'], // 单独页面按钮操作权限
      pagePermission: []
    }
  }]
},
// 名片
{
  path: '/businessCard',
  component: 'Layout',
  redirect: '/businessCard/staffCard',
  meta: { // 所有要展示在菜单里的路由都添加在这边
    'menuName': 'BusinessCard', // 一级菜单标题
    'icon': 'icon-mingpian', // 一级菜单的图标
    'subNavName': [{
      name: 'CardInfo', // 二级菜单的下拉的标题
      url: [{
        name: 'StaffCard', // 三级菜单的标题
        url: '/businessCard/staffCard' // 三级菜单的路由
      },
      {
        name: 'ImpressionLabel', // 三级菜单的标题
        url: '/businessCard/tag' // 三级菜单的路由
      }
      ]
    },
    {
      name: 'CardSetting',
      url: [{
        name: 'ExemptionPassword',
        url: '/businessCard/exemptionPwd'
      },
      {
        name: 'MobileSetting',
        url: '/businessCard/mobileSetting'
      },
      {
        name: 'MediaSetting',
        url: '/businessCard/mediaSetting'
      },
      {
        name: 'CardSetting',
        url: '/businessCard/cardSetting'
      }
      ]
    }
    ]
  },
  children: [ // 子菜单路由表
    // 名片管理
    {
      path: 'staffCard',
      name: 'StaffCard',
      component: '/businessCard/manage/staffCard',
      meta: {
        keepAlive: true,
        title: 'CardManage', // 页面头部的标题
        isOnly: false, // 多页面
        auth: [],
        pagePermission: [ // 页面权限
          {
            title: 'StaffCard',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    },
    // 名片编辑
    {
      path: 'editCard',
      name: 'EditCard',
      component: '/businessCard/manage/editCard',
      meta: {
        refresh: false,
        title: 'CardManage', // 页面头部的标题
        isOnly: false, // 多页面
        auth: [],
        pagePermission: [ // 页面权限
          {
            title: 'EditCard',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    },
    // 印象标签
    {
      path: 'tag',
      name: 'ImpressionLabel',
      component: '/businessCard/manage/tag',
      meta: {
        keepAlive: true,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'ImpressionLabel',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 免审口令
    {
      path: 'exemptionPwd',
      name: 'ExemptionPassword',
      component: '/businessCard/set/exemptionPwd',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'ExemptionPassword',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 手机端设置
    {
      path: 'mobileSetting',
      name: 'MobileSetting',
      component: '/businessCard/set/mobileSetting',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'MobileSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 媒体设置
    {
      path: 'mediaSetting',
      name: 'MediaSetting',
      component: '/businessCard/set/mediaSetting',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'MediaSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 名片设置
    {
      path: 'cardSetting',
      name: 'CardSetting',
      component: '/businessCard/set/cardSetting',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'CardSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    }
  ]
},
// 商城
{
  path: '/malls',
  component: 'Layout',
  redirect: '/malls/list',
  meta: { // 所有要展示在菜单里的路由都添加在这边
    'menuName': 'Malls', // 一级菜单标题
    'icon': 'icon-gouwudai', // 一级菜单的图标
    'subNavName': [{
      name: 'MallsManage', // 二级菜单的下拉的标题
      url: [{
        name: 'GoodsList', // 三级菜单的标题
        url: '/malls/list' // 三级菜单的路由
      },
      {
        name: 'GoodsClassify', // 三级菜单的标题
        url: '/malls/classify' // 三级菜单的路由
      },
      {
        name: 'ParameterManagement', // 三级菜单的标题
        url: '/malls/parameter' // 三级菜单的路由
      }
      ]
    },
    {
      name: 'StoreManage',
      url: [{
        name: 'StoreList',
        url: '/malls/storeManage'
      }
      ]
    },
    {
      name: 'OrderManage',
      url: [{
        name: 'OrderManage',
        url: '/malls/orderManage'
      },
      {
        name: 'RefundManage',
        url: '/malls/refundManage'
      }
      ]
    },
    {
      name: 'MarketingManage',
      url: [{
        name: 'AssembleList',
        url: '/malls/assemble'
      },
      {
        name: 'RedPackit',
        url: '/malls/redPackit'
      }
      ]
    },
    {
      name: 'MallsSet',
      url: [{
        name: 'DealSet',
        url: '/malls/dealSet'
      },
      {
        name: 'VirtualPaymentSet',
        url: '/malls/virtualPayment'
      },
      {
        name: 'StaffChoiceGoods',
        url: '/malls/staffGoods'
      },
      {
        name: 'PaymentSetting',
        url: '/malls/paymentSetting'
      },
      {
        name: 'MallsBanner',
        url: '/malls/banner'
      }
      ]
    },
    {
      name: 'Distributioninfo',
      url: [{
        name: 'ProfitInfo',
        url: '/malls/profit'
      },
      {
        name: 'CommissionInfo',
        url: '/malls/commission'
      },
      {
        name: 'TakeCashInfo',
        url: '/malls/cash'
      },
      {
        name: 'DistributionRelation',
        url: '/malls/relation'
      },
      {
        name: 'DistributionSetting',
        url: '/malls/disSet'
      },
      {
        name: 'DistributionCash',
        url: '/malls/disCash'
      },
      {
        name: 'DistributionAudit',
        url: '/malls/disaudit'
      }
      ]
    }
    ]
  },
  children: [ // 子菜单路由表
    // 商品列表
    {
      path: 'list',
      name: 'GoodsList',
      component: '/malls/goods/list',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'MallsSet', // 页面头部的标题
        isOnly: false, // 多页面
        auth: [],
        pagePermission: [ // 页面权限
          {
            title: 'GoodsList',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    },
    // 商品分类
    {
      path: 'classify',
      name: 'GoodsClassify',
      component: '/malls/goods/classify',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'GoodsClassify',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'parameter',
      name: 'ParameterManagement',
      component: '/malls/goods/parameter',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'ParameterManagement',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'addSpecs',
      name: 'AddSpecs',
      component: '/malls/goods/addSpecs',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'SpecsClassify',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 添加分类
    {
      path: 'addClassify',
      name: 'SpecsClassify',
      component: '/malls/goods/addClassify',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'AddClassify',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 一级参数列表
    {
      path: 'parimary',
      name: 'parimar',
      component: '/malls/goods/parimary',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'parimar',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 二级参数列表
    {
      path: 'secndparimary',
      name: 'secndParimar',
      component: '/malls/goods/secndparimary',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'secndParimar',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 商品编辑
    {
      path: 'edit',
      name: 'GoodsEdit',
      component: '/malls/goods/edit',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'GoodsEdit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 配送服务
    {
      path: 'storeManage',
      name: 'StoreList',
      component: '/malls/store/list',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'StoreList',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 编辑自提点
    {
      path: 'store',
      name: 'StoreAdd',
      component: '/malls/store/edit',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'StoreAdd',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 订单管理
    {
      path: 'orderManage',
      name: 'OrderManage',
      component: '/malls/order/manage',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'OrderManage',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 订单详情
    {
      path: 'orderDetail',
      name: 'OrderDetail',
      component: '/malls/order/detail',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'OrderDetail',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 退款管理
    {
      path: 'refundManage',
      name: 'RefundManage',
      component: '/malls/order/refund',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'RefundManage',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 最新开团
    {
      path: 'newAssemble',
      name: 'NewAssemble',
      component: '/malls/marketing/newAssemble',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'NewAssemble',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 拼团信息
    {
      path: 'assemble',
      name: 'AssembleList',
      component: '/malls/marketing/assemble',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'AssembleList',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 拼团管理（添加拼团规则）AssembleManage
    {
      path: 'assembleManage',
      name: 'AssembleManage',
      component: '/malls/marketing/assembleManage',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'AssembleManage',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 福包管理
    {
      path: 'redPackit',
      name: 'RedPackit',
      component: '/malls/marketing/redPackit',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'RedPackit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 添加福包
    {
      path: 'addRedPackit',
      name: 'EditRedPackit',
      component: '/malls/marketing/addRedPackit',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'EditRedPackit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 交易设置
    {
      path: 'dealSet',
      name: 'DealSet',
      component: '/malls/set/deal',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'DealSet',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 虚拟支付设置
    {
      path: 'virtualPayment',
      name: 'VirtualPaymentSet',
      component: '/malls/set/payment',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'VirtualPaymentSet',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'banner',
      name: 'MallsBanner',
      component: '/malls/set/banner',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'MallsBanner',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'editBanner',
      name: 'EditBanner',
      component: '/malls/set/editBanner',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'EditBanner',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 员工选择商品
    {
      path: 'staffGoods',
      name: 'StaffChoiceGoods',
      component: '/malls/set/staffGoods',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'StaffChoiceGoods',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'paymentSetting',
      name: 'PaymentSetting',
      component: '/malls/set/paymentSetting',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'PaymentSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 分销
    {
      path: 'profit',
      component: '/malls/distribution/profit',
      name: 'ProfitInfo',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'ProfitInfo',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'commission',
      component: '/malls/distribution/commission',
      name: 'CommissionInfo',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'CommissionInfo',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'cash',
      component: '/malls/distribution/takeCash',
      name: 'TakeCashInfo',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'TakeCashInfo',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'relation',
      component: '/malls/distribution/relation',
      name: 'DistributionRelation',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'DistributionRelation',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'disSet',
      component: '/malls/distribution/set',
      name: 'DistributionSetting',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'disCash',
      component: '/malls/distribution/cash',
      name: 'DistributionCash',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionCash',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'disaudit',
      component: '/malls/distribution/audit',
      name: 'DistributionAudit',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionAudit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    }
  ]
},
// 动态
{
  path: '/dynamic',
  component: 'Layout',
  redirect: '/dynamic/manage',
  meta: {
    'menuName': 'Dynamic',
    'icon': 'icon-dongtai1',
    'subNavName': [{
      name: 'DynamicManage', // 二级菜单的下拉的标题
      url: [{
        name: 'DynamicManage', // 三级菜单的标题
        url: '/dynamic/manage' // 三级菜单的路由
      },
      {
        name: 'CommentManage', // 三级菜单的标题
        url: '/dynamic/comment' // 三级菜单的路由
      }
      ]
    }, {
      name: 'DynamicSet', // 二级菜单的下拉的标题
      url: [{
        name: 'DynamicSet', // 三级菜单的标题
        url: '/dynamic/set' // 三级菜单的路由
      },
      {
        name: 'DynamicClassifySet', // 三级菜单的标题
        url: '/dynamic/classifySet' // 三级菜单的路由
      }
      ]
    }]
  },
  children: [{
    path: 'manage',
    name: 'DynamicManage',
    component: '/dynamic/manage',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'DynamicManage',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'comment',
    name: 'CommentManage',
    component: '/dynamic/comment',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'CommentManage',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'classifySet',
    name: 'DynamicClassifySet',
    component: '/dynamic/classifySet',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'DynamicClassifySet',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'editOrdinary',
    name: 'EditOrdinary',
    component: '/dynamic/addOrdinary',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditOrdinary',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editLink',
    name: 'EditLink',
    component: '/dynamic/addLink',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditLink',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editVideo',
    name: 'EditVideo',
    component: '/dynamic/addVideo',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditVideo',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'set',
    name: 'DynamicSet',
    component: '/dynamic/set',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'DynamicSet',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  }
  ]
},
// 官网
{
  path: '/website',
  component: 'Layout',
  redirect: '/website/column',
  meta: {
    'menuName': 'Website',
    'icon': 'icon-guanwang',
    'subNavName': [{
      name: 'WebSiteInfo', // 产品管理
      url: [{
        name: 'WebsiteColumn',
        url: '/website/column'
      }]
    }]
  },
  children: [{
    path: 'column',
    name: 'WebsiteColumn', // 产品分类管理
    component: '/website/info/column',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      keepAlive: true,
      auth: [],
      pagePermission: [{
        title: 'WebsiteColumn',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editModule',
    name: 'EditModule',
    component: '/website/info/editModule',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditModule',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'newsList', // 新闻列表
    name: 'newsList',
    component: '/website/info/module/news',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      keepAlive: true,
      auth: [],
      pagePermission: [{
        title: 'newsList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editNews', // 编辑新闻
    name: 'NewsEdit',
    component: '/website/info/module/newsEdit',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'NewsEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'imgText', // 图文编辑
    name: 'imgText',
    component: '/website/info/module/imgText',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'imgText',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'recruit', // 招聘
    name: 'recruit',
    component: '/website/info/module/recruit',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'recruit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editRecruit', // 招聘编辑
    name: 'RecruitEdit',
    component: '/website/info/module/editRecruit',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'RecruitEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'contact', // 联系
    name: 'contact',
    component: '/website/info/module/contact',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'contact',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'staff', // 员工
    name: 'staff',
    component: '/website/info/module/staff',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'staff',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editStaff', // 员工
    name: 'EditStaff',
    component: '/website/info/module/addStaff',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditStaff',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'video', // 视频
    name: 'video',
    component: '/website/info/module/video',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'video',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editVideo', // 视频
    name: 'VideoEdit',
    component: '/website/info/module/videoEdit',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VideoEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'videoClassify', // 视频
    name: 'VideoClassify',
    component: '/website/info/module/videoClassify',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VideoClassify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'form', // 表单
    name: 'form',
    component: '/website/info/module/form',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'form',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 客户
{
  path: '/customer',
  component: 'Layout',
  redirect: '/customer/list',
  meta: {
    'menuName': 'Customer',
    'icon': 'icon-kehu',
    'subNavName': [{
      name: 'CustomerInfo',
      url: [{
        name: 'CustomerList',
        url: '/customer/list'
      },
      {
        name: 'StaffHandover',
        url: '/customer/handover'
      }
      ]
    },
    {
      name: 'CustomerTalkingSkill',
      url: [{
        name: 'TalkingSkillList',
        url: '/customer/talkingSkill'
      },
      {
        name: 'TalkingSkillClassify',
        url: '/customer/classify'
      }
      ]
    },
    {
      name: 'CustomerQuestionnaire',
      url: [{
        name: 'QuestionnaireList',
        url: '/customer/qList'
      },
      {
        name: 'QuestionnaireSetting',
        url: '/customer/qSetting'
      }
      ]
    }
    ]
  },
  children: [{
    path: 'list',
    component: '/customer/info/list',
    name: 'CustomerList',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'CustomerList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'handover',
    component: '/customer/info/handover',
    name: 'StaffHandover',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'StaffHandover',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'talkingSkill',
    component: '/customer/talkingSkill/list',
    name: 'TalkingSkillList',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'TalkingSkillList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'classify',
    component: '/customer/talkingSkill/classify',
    name: 'TalkingSkillClassify',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'TalkingSkillClassify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'qList',
    component: '/customer/questionnaire/list',
    name: 'QuestionnaireList',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'QuestionnaireList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'qEdit',
    component: '/customer/questionnaire/edit',
    name: 'QuestionnaireEdit',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'QuestionnaireEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'qSetting',
    component: '/customer/questionnaire/setting',
    name: 'QuestionnaireSetting',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'QuestionnaireSetting',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'lookInto',
    component: '/customer/info/lookInto',
    name: 'CustomerLookInto',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'CustomerLookInto',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 公司
{
  path: '/company',
  component: 'Layout',
  redirect: '/company/list',
  meta: {
    'menuName': 'Company',
    'icon': 'icon-gongsi',
    'subNavName': [{
      name: 'CompanyInfo',
      url: [{
        name: 'CompanyList',
        url: '/company/list'
      },
      {
        name: 'StoreQRCodeSet',
        url: '/company/qrcodeSet'
      }
      ]
    },
    {
      name: 'PostInfo',
      url: [{
        name: 'PostManage',
        url: '/company/postManage'
      }]
    }
    ]
  },
  children: [{
    path: 'addCompany',
    name: 'EditCompany',
    component: '/company/manage/addCompany',
    meta: {
      keepAlive: true,
      title: 'CompanyManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditCompany',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'qrcodeSet',
    name: 'StoreQRCodeSet',
    component: '/company/manage/qrcode',
    meta: {
      keepAlive: true,
      title: 'CompanyManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'StoreQRCodeSet',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'list',
    name: 'CompanyList',
    component: '/company/manage/list',
    meta: {
      keepAlive: true,
      title: 'CompanyManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CompanyList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'postManage',
    name: 'PostManage',
    component: '/company/manage/postManage',
    meta: {
      keepAlive: true,
      title: 'CompanyManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'PostManage',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  }
  ]
},
// 系统
{
  path: '/sys',
  component: 'Layout',
  redirect: '/sys/config',
  meta: {
    'menuName': 'System',
    'icon': 'icon-xitong',
    'subNavName': [{
      name: 'SProSetting',
      url: [{
        name: 'SProConfig',
        url: '/sys/config'
      },
      {
        name: 'SProLink',
        url: '/sys/link'
      },
      {
        name: 'SProPayment',
        url: '/sys/payment'
      },
      {
        name: 'SProWechat',
        url: '/sys/wechat'
      }
      ]
    },
    {
      name: 'OtherSetting',
      url: [{
        name: 'CopyrightConfig',
        url: '/sys/copyright'
      },
      {
        name: 'AllNotice',
        url: '/sys/clientNotice'
      },
      {
        name: 'UploadConfig',
        url: '/sys/upload'
      }
      ]
    }
    ]
  },
  children: [{
    path: 'config',
    name: 'SProConfig',
    component: '/system/smallProcedure/config',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SProConfig',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'link',
    name: 'SProLink',
    component: '/system/smallProcedure/link',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SProLink',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'payment',
    name: 'SProPayment',
    component: '/system/smallProcedure/payment',
    meta: {
      title: 'SystemSetting',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'SProPayment',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'wechat',
    name: 'SProWechat',
    component: '/system/smallProcedure/wechat',
    meta: {
      title: 'SystemSetting',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'SProWechat',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'tabbar',
    name: 'TabbarSetting',
    component: '/system/smallProcedure/tabbar',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'TabbarSetting',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'copyright',
    name: 'CopyrightConfig',
    component: '/system/other/copyright',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'CopyrightConfig',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'upload',
    name: 'UploadConfig',
    component: '/system/other/uploadConfig',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'UploadConfig',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'clientNotice',
    name: 'AllNotice',
    component: '/system/other/clientNotice',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'clientNotice',
        url: '/sys/clientNotice',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'radarNotice',
        url: '/sys/radarNotice',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'radarNotice',
    name: 'AllNotice',
    component: '/system/other/radarNotice',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'clientNotice',
        url: '/sys/clientNotice',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'radarNotice',
        url: '/sys/radarNotice',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'site',
    name: 'SiteBinding',
    component: '/system/other/site',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SiteBinding',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 装修
{
  path: '/renovation',
  component: 'Layout',
  redirect: '/renovation/case',
  meta: {
    'menuName': 'Renovation',
    'icon': 'icon-zhuangxiu',
    'subNavName': [{
      name: 'RenovationCase',
      url: [{
        name: 'CaseList',
        url: '/renovation/case'
      }]
    },
    {
      name: 'BuildingSite',
      url: [{
        name: 'SiteList',
        url: '/renovation/site'
      },
      {
        name: 'SiteDynamic',
        url: '/renovation/siteDynamic'
      }
      ]
    },
    {
      name: 'RenovationStrategy',
      url: [{
        name: 'StrategyList',
        url: '/renovation/strategy'
      },
      {
        name: 'StrategyClassify',
        url: '/renovation/strategyClassify'
      }
      ]
    },
    {
      name: 'MasterTeam',
      url: [{
        name: 'TeamList',
        url: '/renovation/master'
      }]
    },
    {
      name: 'RenovationMarketingManage',
      url: [{
        name: 'IntelligenceOffer',
        url: '/renovation/offer'
      },
      {
        name: 'FreeDesign',
        url: '/renovation/design'
      }
      ]
    },
    {
      name: 'RenovationSetting',
      url: [{
        name: 'RenovationScreenMange',
        url: '/renovation/screen/regionSetting'
      }]
    },
    {
      name: 'RenovationAbout',
      url: [{
        name: 'CompanyProfile',
        url: '/renovation/about/index'
      }]
    }
    ]
  },
  children: [{
    path: 'case',
    name: 'CaseList',
    component: '/renovation/case/list',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'CaseList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editCase',
    name: 'EditCase',
    component: '/renovation/case/edit',
    meta: {
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'EditCase',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'site',
    name: 'SiteList',
    component: '/renovation/site/list',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SiteList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editSite',
    name: 'EditSite',
    component: '/renovation/site/edit',
    meta: {
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'EditSite',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'siteDynamic',
    name: 'SiteDynamic',
    component: '/renovation/site/dynamic',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SiteDynamic',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'dyDetail',
    name: 'SiteDynamicDetail',
    component: '/renovation/site/detail',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SiteDynamicDetail',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'strategy',
    name: 'StrategyList',
    component: '/renovation/strategy/list',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'StrategyList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editStrategy',
    name: 'EditStrategy',
    component: '/renovation/strategy/edit',
    meta: {
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'EditStrategy',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'strategyClassify',
    name: 'StrategyClassify',
    component: '/renovation/strategy/classify',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'StrategyClassify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'master',
    name: 'TeamList',
    component: '/renovation/master/list',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'TeamList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'offer',
    name: 'IntelligenceOffer',
    component: '/renovation/offer/list',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'IntelligenceOffer',
        index: 0,
        url: '/renovation/offer',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'OfferContentSetting',
        index: 1,
        url: '/renovation/offerSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'offerSetting',
    name: 'OfferContentSetting',
    component: '/renovation/offer/setting',
    meta: {
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'IntelligenceOffer',
        index: 0,
        url: '/renovation/offer',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'OfferContentSetting',
        index: 1,
        url: '/renovation/offerSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'design',
    name: 'FreeDesign',
    component: '/renovation/design/list',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'FreeDesign',
        index: 0,
        url: '/renovation/design',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'DesignContentSetting',
        index: 1,
        url: '/renovation/designSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'designSetting',
    name: 'DesignContentSetting',
    component: '/renovation/design/setting',
    meta: {
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'FreeDesign',
        index: 0,
        url: 'design',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'DesignContentSetting',
        index: 1,
        url: '/renovation/designSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'screen/regionSetting',
    name: 'RenovationScreenRegionSet',
    component: '/renovation/screen/region',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'RegionSetting',
        index: 0,
        url: '/renovation/screen/regionSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AreaSetting',
        index: 1,
        url: '/renovation/screen/areaSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'TotalPriceSetting',
        index: 2,
        url: '/renovation/screen/priceSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StyleSetting',
        index: 3,
        url: '/renovation/screen/styleSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ApartmentSetting',
        index: 4,
        url: '/renovation/screen/apartmentSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StageSetting',
        index: 5,
        url: '/renovation/screen/stageSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'screen/areaSetting',
    name: 'RenovationScreenAreaSet',
    component: '/renovation/screen/area',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'RegionSetting',
        index: 0,
        url: '/renovation/screen/regionSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AreaSetting',
        index: 1,
        url: '/renovation/screen/areaSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'TotalPriceSetting',
        index: 2,
        url: '/renovation/screen/priceSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StyleSetting',
        index: 3,
        url: '/renovation/screen/styleSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ApartmentSetting',
        index: 4,
        url: '/renovation/screen/apartmentSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StageSetting',
        index: 5,
        url: '/renovation/screen/stageSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'screen/priceSetting',
    name: 'RenovationScreenTotalPriceSet',
    component: '/renovation/screen/price',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'RegionSetting',
        index: 0,
        url: '/renovation/screen/regionSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AreaSetting',
        index: 1,
        url: '/renovation/screen/areaSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'TotalPriceSetting',
        index: 2,
        url: '/renovation/screen/priceSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StyleSetting',
        index: 3,
        url: '/renovation/screen/styleSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ApartmentSetting',
        index: 4,
        url: '/renovation/screen/apartmentSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StageSetting',
        index: 5,
        url: '/renovation/screen/stageSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'screen/styleSetting',
    name: 'RenovationScreenStyleSet',
    component: '/renovation/screen/style',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'RegionSetting',
        index: 0,
        url: '/renovation/screen/regionSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AreaSetting',
        index: 1,
        url: '/renovation/screen/areaSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'TotalPriceSetting',
        index: 2,
        url: '/renovation/screen/priceSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StyleSetting',
        index: 3,
        url: '/renovation/screen/styleSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ApartmentSetting',
        index: 4,
        url: '/renovation/screen/apartmentSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StageSetting',
        index: 5,
        url: '/renovation/screen/stageSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'screen/apartmentSetting',
    name: 'RenovationScreenApartmentSet',
    component: '/renovation/screen/apartment',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'RegionSetting',
        index: 0,
        url: '/renovation/screen/regionSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AreaSetting',
        index: 1,
        url: '/renovation/screen/areaSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'TotalPriceSetting',
        index: 2,
        url: '/renovation/screen/priceSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StyleSetting',
        index: 3,
        url: '/renovation/screen/styleSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ApartmentSetting',
        index: 4,
        url: '/renovation/screen/apartmentSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StageSetting',
        index: 5,
        url: '/renovation/screen/stageSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'screen/stageSetting',
    name: 'RenovationScreenStageSet',
    component: '/renovation/screen/stage',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'RegionSetting',
        index: 0,
        url: '/renovation/screen/regionSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AreaSetting',
        index: 1,
        url: '/renovation/screen/areaSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'TotalPriceSetting',
        index: 2,
        url: '/renovation/screen/priceSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StyleSetting',
        index: 3,
        url: '/renovation/screen/styleSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ApartmentSetting',
        index: 4,
        url: '/renovation/screen/apartmentSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StageSetting',
        index: 5,
        url: '/renovation/screen/stageSetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'about/index',
    name: 'CompanyProfile',
    component: '/renovation/about/index',
    meta: {
      keepAlive: true,
      title: 'RenovationManage',
      auth: ['view', 'add', 'edit', 'del', 'outport'],
      isOnly: true,
      pagePermission: [{
        title: 'CompanyProfile',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 美业
{
  path: '/prettify',
  component: 'Layout',
  redirect: '/prettify/subscribelist',
  meta: {
    menuName: 'Prettify',
    icon: 'icon-zhuangxiu',
    subNavName: [
      {
        name: 'SubscribeManage',
        url: [{
          name: 'SubscribeList',
          url: '/prettify/subscribelist'
        },
        {
          name: 'SubscribeTechnicianSet',
          url: '/prettify/subTechnicianSet'
        }
        ]
      },
      {
        name: 'ServiceManage',
        url: [
          {
            name: 'ServiceList',
            url: '/prettify/serviceList'
          },
          {
            name: 'PrettifyServiceClassify',
            url: '/prettify/serviceClassify'
          },
          {
            name: 'ServiceOrder',
            url: '/prettify/serviceOrder'
          },
          {
            name: 'ServiceRefund',
            url: '/prettify/serviceRefund'
          },
          {
            name: 'ServiceCoupon',
            url: '/prettify/serviceCoupon'
          }
        ]
      },
      {
        name: 'SalesPromotion',
        url: [
          {
            name: 'ActivityList',
            url: '/prettify/activity'
          }
        ]
      },
      {
        name: 'ShopManage',
        url: [
          {
            name: 'ShopQRCode',
            url: '/prettify/qrcode'
          }
        ]
      },
      {
        name: 'AchievementManage',
        url: [
          {
            name: 'OrderDeduction',
            url: '/prettify/deduction'
          }
        ]
      }
    ]
  },
  children: [
    {
      path: 'subscribelist',
      name: 'SubscribeList',
      component: '/prettify/subscribe/list',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'SubscribeList',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'subTechnicianSet',
      name: 'SubscribeTechnicianSet',
      component: '/prettify/subscribe/technicianSet',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'SubscribeTechnicianSet',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'serviceList',
      name: 'ServiceList',
      component: '/prettify/service/list',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceList',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'serviceEdit',
      name: 'ServiceEdit',
      component: '/prettify/service/edit',
      meta: {
        keepAlive: false,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceEdit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'serviceClassify',
      name: 'PrettifyServiceClassify',
      component: '/prettify/service/classify',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'PrettifyServiceClassify',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'serviceOrder',
      name: 'ServiceOrder',
      component: '/prettify/service/order',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceOrder',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'serviceRefund',
      name: 'ServiceRefund',
      component: '/prettify/service/refund',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceRefund',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'serviceCoupon',
      name: 'ServiceCoupon',
      component: '/prettify/service/coupon',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceCoupon',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'couponEdit',
      name: 'ServiceCouponEdit',
      component: '/prettify/service/editCoupon',
      meta: {
        keepAlive: false,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceCouponEdit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'activity',
      name: 'ActivityList',
      component: '/prettify/activity/list',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ActivityList',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'activityEdit',
      name: 'ActivityEdit',
      component: '/prettify/activity/edit',
      meta: {
        keepAlive: false,
        title: 'PrettifyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ActivityEdit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'qrcode',
      name: 'ShopQRCode',
      component: '/prettify/shop/qrcode',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'ShopQRCode',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'deduction',
      name: 'OrderDeduction',
      component: '/prettify/achievement/order',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        isOnly: false,
        auth: [],
        pagePermission: [
          {
            title: 'OrderDeduction',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    },
    {
      path: 'commissionDetail',
      name: 'DetailsOfCommission',
      component: '/prettify/achievement/detail',
      meta: {
        keepAlive: true,
        title: 'PrettifyManage',
        isOnly: false,
        auth: [],
        pagePermission: [
          {
            title: 'DetailsOfCommission',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    }
  ]
},
// 健身
{
  path: '/fitness',
  component: 'Layout',
  redirect: '/fitness/coursePlanList',
  meta: {
    'menuName': 'fitness',
    'icon': 'icon-zhuangxiu',
    'subNavName': [{
      name: 'courseManage',
      url: [{
        name: 'coursePlanList',
        url: '/fitness/coursePlanList'
      },
      {
        name: 'courseList',
        url: '/fitness/courseList'
      }
      ]
    }]
  },
  children: [{
    path: 'coursePlanList',
    name: 'coursePlanList',
    component: '/fitness/coursePlan/list',
    meta: {
      keepAlive: true,
      title: 'fitnessManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'coursePlanList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'coursePlanEdit',
    name: 'coursePlanEdit',
    component: '/fitness/coursePlan/edit',
    meta: {
      title: 'fitnessManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'coursePlanEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'courseList',
    name: 'courseList',
    component: '/fitness/course/list',
    meta: {
      keepAlive: true,
      title: 'fitnessManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'courseList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'courseEdit',
    name: 'courseEdit',
    component: '/fitness/course/edit',
    meta: {
      title: 'fitnessManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'courseEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},

//  短视频
{
  path: '/shortvideo',
  component: 'Layout',
  redirect: '/shortvideo/list',
  meta: {
    'menuName': 'ShortVideo',
    'icon': 'iconShortVideo1',
    'subNavName': [{
      name: 'ShortVideoManageNav',
      url: [{
        name: 'ShortVideoList',
        url: '/shortvideo/list'
      }, {
        name: 'ShortVideoManage',
        url: '/shortvideo/manage'
      }
      ]
    }]
  },
  children: [
    {
      path: 'list',
      name: 'ShortVideo',
      component: '/application/shortvideo/list',
      meta: {
        keepAlive: true,
        title: 'ShortVideo',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShortVideoManageNav',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'manage',
      name: 'ShortVideo',
      component: '/application/shortvideo/manage',
      meta: {
        keepAlive: true,
        title: 'ShortVideo',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShortVideoManage',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'edit',
      name: 'ShortVideo',
      component: '/application/shortvideo/edit',
      meta: {
        keepAlive: true,
        title: 'ShortVideo',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShortVideoEdit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'record',
      name: 'ShortVideo',
      component: '/application/shortvideo/record',
      meta: {
        keepAlive: true,
        title: 'ShortVideo',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShortVideoRecord',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    }]
},
// diy
{
  path: '/diy',
  component: 'Layout',
  redirect: '/diy/list',
  meta: {
    'menuName': 'diy',
    'icon': 'iconchaifenyemian',
    'subNavName': [{
      name: 'diySub',
      url: [{
        name: 'diyList',
        url: '/diy/list'
      }, {
        name: 'diyColor',
        url: '/diy/color'
      }]
    }]
  },
  children: [{
    path: 'list',
    name: 'diyList',
    component: '/diy/list',
    meta: {
      keepAlive: true,
      title: 'diySub',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'diyList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }, {
    path: 'color',
    name: 'diyColor',
    component: '/diy/color',
    meta: {
      keepAlive: true,
      title: 'diySub',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'diyColor',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'edit',
    name: 'diySub',
    component: '/diy/edit',
    meta: {
      title: 'diySub',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'diySub',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 应用
{
  path: '/app',
  component: 'Layout',
  redirect: '/app/tool',
  meta: {
    'menuName': 'App',
    img: require('@/assets/icon/apps.png'),
    'subNavName': [{
      name: 'AppCenter',
      url: [{
        name: 'AppTool',
        url: '/app/tool'
      }]
    }]
  },
  children: [{
    path: 'tool',
    name: 'AppTool',
    component: '/application/tool',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'AppTool',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  // 扫码支付
  {
    path: 'sweepPayment/code',
    name: 'SweepPaymentCode',
    component: '/application/sweepPayment/code',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PaymentCode',
        url: '/app/sweepPayment/code',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PaymentRecord',
        url: '/app/sweepPayment/record',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Swiper',
        url: '/app/sweepPayment/swiper',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'BasicSetting',
        url: '/app/sweepPayment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'sweepPayment/record',
    name: 'SweepPaymentRecord',
    component: '/application/sweepPayment/record',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PaymentCode',
        url: '/app/sweepPayment/code',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PaymentRecord',
        url: '/app/sweepPayment/record',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Swiper',
        url: '/app/sweepPayment/swiper',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'BasicSetting',
        url: '/app/sweepPayment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'sweepPayment/swiper',
    name: 'SweepPaymentSwiper',
    component: '/application/sweepPayment/swiper',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PaymentCode',
        url: '/app/sweepPayment/code',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PaymentRecord',
        url: '/app/sweepPayment/record',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Swiper',
        url: '/app/sweepPayment/swiper',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'BasicSetting',
        url: '/app/sweepPayment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'sweepPayment/setting',
    name: 'SweepPaymentSetting',
    component: '/application/sweepPayment/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PaymentCode',
        url: '/app/sweepPayment/code',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PaymentRecord',
        url: '/app/sweepPayment/record',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Swiper',
        url: '/app/sweepPayment/swiper',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'BasicSetting',
        url: '/app/sweepPayment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'sweepPayment/addSwiper',
    name: 'SweepPaymentAddSwiper',
    component: '/application/sweepPayment/addSwiper',
    meta: {
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'EditSwiper',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  // 获客海报
  {
    path: 'poster/classify',
    name: 'GuestWinningPosterClassify',
    component: '/application/poster/classify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PosterClassify',
        url: '/app/poster/classify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PosterList',
        url: '/app/poster/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'poster/list',
    name: 'GuestWinningPosterList',
    component: '/application/poster/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PosterClassify',
        url: '/app/poster/classify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PosterList',
        url: '/app/poster/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'poster/edit',
    name: 'GuestWinningPosterEdit',
    component: '/application/poster/editPoster',
    meta: {
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'EditPoster',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  // 群发
  {
    path: 'group/msg',
    name: 'GMsg',
    component: '/application/groupPush/msg',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'GMsg',
        index: 0,
        url: '/app/group/msg',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GNews',
        url: '/app/group/news',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ContentSetting',
        url: '/app/group/setting',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'group/news',
    name: 'GNews',
    component: '/application/groupPush/news',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'GMsg',
        index: 0,
        url: '/app/group/msg',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GNews',
        url: '/app/group/news',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ContentSetting',
        url: '/app/group/setting',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'group/setting',
    name: 'ContentSetting',
    component: '/application/groupPush/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'GMsg',
        index: 0,
        url: '/app/group/msg',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GNews',
        url: '/app/group/news',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ContentSetting',
        url: '/app/group/setting',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 预约
  {
    path: 'appointment/classify',
    name: 'ServiceClassify',
    component: '/application/appointment/classifyList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        url: '/app/appointment/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentService',
        url: '/app/appointment/service',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GuestOrder',
        url: '/app/appointment/order',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentSetting',
        url: '/app/appointment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'appointment/editService',
    name: 'AddService',
    component: '/application/appointment/editService',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'AddService',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'appointment/order',
    name: 'GuestOrder',
    component: '/application/appointment/order',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        url: '/app/appointment/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentService',
        url: '/app/appointment/service',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GuestOrder',
        url: '/app/appointment/order',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentSetting',
        url: '/app/appointment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'appointment/service',
    name: 'AppointmentService',
    component: '/application/appointment/serviceList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        url: '/app/appointment/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentService',
        url: '/app/appointment/service',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GuestOrder',
        url: '/app/appointment/order',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentSetting',
        url: '/app/appointment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'appointment/setting',
    name: 'AppointmentSetting',
    component: '/application/appointment/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        url: '/app/appointment/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentService',
        url: '/app/appointment/service',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GuestOrder',
        url: '/app/appointment/order',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentSetting',
        url: '/app/appointment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 房产
  {
    path: 'house/classify',
    name: 'HouseClassify',
    component: '/application/houseProperty/classify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/banner',
    name: 'HouseBanner',
    component: '/application/houseProperty/banner',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/manage',
    name: 'HouseManage',
    component: '/application/houseProperty/manage',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/screen',
    name: 'HouseScreenManage',
    component: '/application/houseProperty/screen',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/customer',
    name: 'HouseAppointmentCustomer',
    component: '/application/houseProperty/customer',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/editClassify',
    name: 'EditHouseClassify',
    component: '/application/houseProperty/editClassify',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditHouseClassify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'house/editBanner',
    name: 'EditHouseBanner',
    component: '/application/houseProperty/editBanner',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditHouseBanner',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'house/editHouse',
    name: 'EditHouse',
    component: '/application/houseProperty/editHouse',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditHouse',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  // 预约活动
  {
    path: 'activity/classify',
    name: 'ActivityClassify',
    component: '/application/activity/classify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ActivityClassify',
        index: 0,
        url: '/app/activity/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'SignUpContent',
        url: '/app/activity/content',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ActivityManage',
        url: '/app/activity/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'activity/content',
    name: 'SignUpContent',
    component: '/application/activity/content',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ActivityClassify',
        index: 0,
        url: '/app/activity/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'SignUpContent',
        url: '/app/activity/content',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ActivityManage',
        url: '/app/activity/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'activity/manage',
    name: 'ActivityManage',
    component: '/application/activity/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ActivityClassify',
        index: 0,
        url: '/app/activity/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'SignUpContent',
        url: '/app/activity/content',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ActivityManage',
        url: '/app/activity/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'activity/edit',
    name: 'EditActivity',
    component: '/application/activity/edit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditActivity',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'activity/signUp',
    name: 'SignUpDetail',
    component: '/application/activity/signUp',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'SignUpDetail',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  // 获客文章
  {
    path: 'article/classify',
    name: 'ArticleClassify',
    component: '/application/article/classify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/list',
    name: 'ArticleList',
    component: '/application/article/articleList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/staff',
    name: 'StaffArticle',
    component: '/application/article/staffArticleList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/setting',
    name: 'ArticleSetting',
    component: '/application/article/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/assigne',
    name: 'AssignedArticle',
    component: '/application/article/assignedArticle',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/edit',
    name: 'EditArticle',
    component: '/application/article/editArticle',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditArticle',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  // 百度小程序
  {
    path: 'baidu/setting',
    name: 'BaiduSetting',
    component: '/application/baidu/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'BaiduSetting',
        index: 0,
        url: '/app/baidu/setting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 截流插件
  {
    path: 'closure/setting',
    name: 'ClosureSetting',
    component: '/application/closure/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ClosureSetting',
        index: 0,
        url: '/app/closure/setting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ClosureHelp',
        index: 0,
        url: '/app/closure/help',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'closure/help',
    name: 'ClosureHelp',
    component: '/application/closure/help',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ClosureSetting',
        index: 0,
        url: '/app/closure/setting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ClosureHelp',
        index: 0,
        url: '/app/closure/help',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 带客有礼
  {
    path: 'present/list',
    name: 'PresentList',
    component: '/application/present/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'PresentList',
        index: 0,
        url: '/app/present/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'PresentSet',
        index: 0,
        url: '/app/present/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'present/set',
    name: 'PresentSet',
    component: '/application/present/set',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'PresentList',
        index: 0,
        url: '/app/present/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'PresentSet',
        index: 0,
        url: '/app/present/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'present/edit',
    name: 'PresentEdit',
    component: '/application/present/edit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'PresentEdit',
        index: 0,
        url: '/app/present/edit',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'present/welfare',
    name: 'PresentWelfare',
    component: '/application/present/welfare',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'PresentWelfare',
        index: 0,
        url: '/app/present/welfare',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'present/record',
    name: 'PresentRecord',
    component: '/application/present/record',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'PresentRecord',
        index: 0,
        url: '/app/present/record',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'present/detail',
    name: 'PresentDetail',
    component: '/application/present/detail',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'PresentDetail',
        index: 0,
        url: '/app/present/detail',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 红包插件
  {
    path: 'cash/list',
    name: 'CashList',
    component: '/application/cash/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CashList',
        index: 0,
        url: '/app/cash/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'CashSet',
        index: 0,
        url: '/app/cash/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'CashImage',
        index: 0,
        url: '/app/cash/image',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'cash/set',
    name: 'CashSet',
    component: '/application/cash/set',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CashList',
        index: 0,
        url: '/app/cash/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'CashSet',
        index: 0,
        url: '/app/cash/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'CashImage',
        index: 0,
        url: '/app/cash/image',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'cash/image',
    name: 'CashImage',
    component: '/application/cash/image',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CashList',
        index: 0,
        url: '/app/cash/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'CashSet',
        index: 0,
        url: '/app/cash/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'CashImage',
        index: 0,
        url: '/app/cash/image',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'cash/edit',
    name: 'CashView',
    component: '/application/cash/edit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CashView',
        index: 0,
        url: '/app/cash/edit',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'cash/editImage',
    name: 'CashViewImage',
    component: '/application/cash/editImage',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CashViewImage',
        index: 0,
        url: '/app/cash/editImage',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'cash/record',
    name: 'CashRecord',
    component: '/application/cash/record',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CashRecord',
        index: 0,
        url: '/app/cash/record',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'cash/detail',
    name: 'CashDetail',
    component: '/application/cash/detail',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CashDetail',
        index: 0,
        url: '/app/cash/detail',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 员工发放满减券返佣
  {
    path: 'reduction/code',
    name: 'ReductionCode',
    component: '/application/reduction/code',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionCode',
        index: 0,
        url: '/app/reduction/code',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionPayRecord',
        index: 0,
        url: '/app/reduction/payRecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionList',
        index: 0,
        url: '/app/reduction/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCashout',
        index: 0,
        url: '/app/reduction/cashout',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCommission',
        index: 0,
        url: '/app/reduction/commission',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'reduction/payRecord',
    name: 'ReductionPayRecord',
    component: '/application/reduction/payRecord',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionCode',
        index: 0,
        url: '/app/reduction/code',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionPayRecord',
        index: 0,
        url: '/app/reduction/payRecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionList',
        index: 0,
        url: '/app/reduction/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCashout',
        index: 0,
        url: '/app/reduction/cashout',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCommission',
        index: 0,
        url: '/app/reduction/commission',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'reduction/list',
    name: 'ReductionList',
    component: '/application/reduction/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionCode',
        index: 0,
        url: '/app/reduction/code',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionPayRecord',
        index: 0,
        url: '/app/reduction/payRecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionList',
        index: 0,
        url: '/app/reduction/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCashout',
        index: 0,
        url: '/app/reduction/cashout',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCommission',
        index: 0,
        url: '/app/reduction/commission',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'reduction/cashout',
    name: 'ReductionCashout',
    component: '/application/reduction/cashout',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionCode',
        index: 0,
        url: '/app/reduction/code',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionPayRecord',
        index: 0,
        url: '/app/reduction/payRecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionList',
        index: 0,
        url: '/app/reduction/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCashout',
        index: 0,
        url: '/app/reduction/cashout',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCommission',
        index: 0,
        url: '/app/reduction/commission',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'reduction/commission',
    name: 'ReductionCommission',
    component: '/application/reduction/commission',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionCode',
        index: 0,
        url: '/app/reduction/code',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionPayRecord',
        index: 0,
        url: '/app/reduction/payRecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionList',
        index: 0,
        url: '/app/reduction/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCashout',
        index: 0,
        url: '/app/reduction/cashout',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ReductionCommission',
        index: 0,
        url: '/app/reduction/commission',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'reduction/edit',
    name: 'ReductionEdit',
    component: '/application/reduction/edit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionEdit',
        index: 0,
        url: '/app/reduction/edit',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'reduction/record',
    name: 'ReductionRecord',
    component: '/application/reduction/record',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionRecord',
        index: 0,
        url: '/app/reduction/record',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'reduction/receive',
    name: 'ReductionReceive',
    component: '/application/reduction/receive',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionReceive',
        index: 0,
        url: '/app/reduction/receive',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'reduction/detail',
    name: 'ReductionDetail',
    component: '/application/reduction/detail',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ReductionDetail',
        index: 0,
        url: '/app/reduction/detail',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 直播
  {
    path: 'live/list',
    name: 'LiveList',
    component: '/application/live/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'LiveList',
        index: 0,
        url: '/app/live/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 短视频
  {
    path: 'shortvideo/list',
    name: 'ShortVideoList',
    component: '/application/shortvideo/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ShortVideoList',
        index: 0,
        url: '/app/shortvideo/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ShortVideoManage',
        index: 0,
        url: '/app/shortvideo/manage',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  }, {
    path: 'shortvideo/manage',
    name: 'ShortVideoManage',
    component: '/application/shortvideo/manage',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ShortVideoList',
        index: 0,
        url: '/app/shortvideo/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'ShortVideoManage',
        index: 0,
        url: '/app/shortvideo/manage',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  }, {
    path: 'shortvideo/edit',
    name: 'ShortVideoEdit',
    component: '/application/shortvideo/edit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ShortVideoEdit',
        index: 0,
        url: '/app/shortvideo/edit',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  }, {
    path: 'shortvideo/record',
    name: 'ShortVideoRecord',
    component: '/application/shortvideo/record',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ShortVideoRecord',
        index: 0,
        url: '/app/shortvideo/record',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  // 等级会员
  {
    path: 'vip/list',
    name: 'VipList',
    component: '/application/vip/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VipList',
        index: 0,
        url: '/app/vip/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipLevel',
        index: 0,
        url: '/app/vip/level',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipRight',
        index: 0,
        url: '/app/vip/right',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipSet',
        index: 0,
        url: '/app/vip/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  }, {
    path: 'vip/level',
    name: 'VipLevel',
    component: '/application/vip/level',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VipList',
        index: 0,
        url: '/app/vip/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipLevel',
        index: 0,
        url: '/app/vip/level',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipRight',
        index: 0,
        url: '/app/vip/right',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipSet',
        index: 0,
        url: '/app/vip/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  }, {
    path: 'vip/right',
    name: 'VipRight',
    component: '/application/vip/right',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VipList',
        index: 0,
        url: '/app/vip/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipLevel',
        index: 0,
        url: '/app/vip/level',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipRight',
        index: 0,
        url: '/app/vip/right',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipSet',
        index: 0,
        url: '/app/vip/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  }, {
    path: 'vip/set',
    name: 'VipSet',
    component: '/application/vip/set',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VipList',
        index: 0,
        url: '/app/vip/list',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipLevel',
        index: 0,
        url: '/app/vip/level',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipRight',
        index: 0,
        url: '/app/vip/right',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }, {
        title: 'VipSet',
        index: 0,
        url: '/app/vip/set',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'vip/detail',
    name: 'VipDetail',
    component: '/application/vip/detail',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VipDetail',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'vip/edit',
    name: 'VipLevelEdit',
    component: '/application/vip/edit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VipLevelEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
{
  path: '*',
  redirect: '/404',
  hidden: true
}
]



// WEBPACK FOOTER //
// ./src/permission.js